// local
import { STATE_URL } from './constants.js';
// packages

import {
  createFeed,
  createRaceFeed,
  createCandidateLookup,
  createSubunitLookup,
} from './stores.js';

import {
  renderSvelteComponent,
  findSvelteComponentContainer,
} from './utils/render.js';
import { derived } from 'svelte/store';

// components
import Results from './components/Results.svelte';

/**
 * @type {Map<string, import('../types.jsjs').Crosswalk>}
 */
const crosswalk = window.CROSSWALK.assets.img;

//components

async function main() {
  const apfeed = await createFeed(STATE_URL);
  const propFeed = /**  @type {import('./types.d').RaceFeed}  */ (
    createRaceFeed(apfeed, 'CA-I83069-2024-11-05')
  );

  let propContainer = findSvelteComponentContainer('#Proposition-36');

  renderSvelteComponent(
    Results,
    /** @type {HTMLElement} */
    propContainer,
    {
      feed: propFeed,
      face: false,
      crosswalk,
    }
  );
}

main().catch(console.error);
